var map = {
	"./Marketplace-PNG.png": 3261,
	"./ae.png": 7583,
	"./bg/2418ee_54.jpg": 9989,
	"./bg/Pngtreeyellow.png": 5474,
	"./bg/bg-food.jpg": 1126,
	"./bg/blue-watercolor-circle.png": 7584,
	"./bg/colorful-random dots-pattern.png": 5050,
	"./bg/cropped-logo-thaidrill100.png": 9008,
	"./bg/food-article.png": 1862,
	"./bg/food-cuisine.jpg": 3814,
	"./bg/food-normal.png": 5208,
	"./bg/food-seamlessbackground.png": 9636,
	"./bg/forgot-password.png": 1968,
	"./bg/gourmet-food-hot-pot.png": 5602,
	"./bg/pink-watercolor-circle.png": 4866,
	"./bg/red-watercolor-circle-3.png": 1081,
	"./bg/super-market.png": 59,
	"./bg/thankyou.png": 1193,
	"./bg/watercolor-circle-green.png": 1845,
	"./bg/watercolor-circle-orange.png": 9414,
	"./bg/watercolor-circles.png": 6598,
	"./bg/yellow-circle.png": 4754,
	"./bg/yellow-watercolor-circle.png": 5641,
	"./food-normal.png": 4464,
	"./grilled-chicken-and-sticky-rice.webp": 5212,
	"./hand-painted anime food.png": 8470,
	"./laundry-service.png": 9393,
	"./painted delicious fried rice cake.png": 842,
	"./super-market.png": 8155,
	"./thai tom yum goon.png": 7110,
	"./washing-machine.png": 979,
	"./woman-doing-laundry-wash.png": 539
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8071;